import React from 'react';
import './Button.css';

interface Props {
  text: string;
  isAnimating: boolean;
}
const Button = ({ text, isAnimating }: Props) => (
  <button type="submit" className="button" disabled={isAnimating}>
    {isAnimating ? (
      <div className="spinner" data-testid="button-animation">
        <div className="s1"></div>
        <div className="s2"></div>
        <div className="s3"></div>
      </div>
    ) : (
      text
    )}
  </button>
);

export default Button;
